export const screenXxsMin = 375;

// Extra small screen / phone
export const screenXsMin = 480;

// Small screen / tablet
export const screenSmMin = 768;

// Medium screen / desktop
export const screenMdMin = 992;

// Large screen / wide desktop
export const screenLgMin = 1100;

// Large screen / wide desktop
export const screenXlMin = 1200;

export const siteWidth = screenXlMin;
